import {getToken} from "./firebase";
import {callAuthApi} from "./api";
import {unverifiedModalToggle} from "./dom";


export default function INIT() {
    (document.getElementById("login-button") as HTMLButtonElement).addEventListener("click", signIn);
}

async function signIn(): Promise<void> {
    try {
        const token = await getToken();
        const response = await callAuthApi(token);

        if (response.status === 403) {
            unverifiedModalToggle.click();
        } else if (response.redirected) {
            window.location.href = response.url;
        } else {
            alert("Something went wrong... Try again later.");
        }
    } catch (e) {
        console.error(e);
        alert("Error signing in");
    }
}